/** Thrown when API returns 402 require_tier1_access */
export const PAYWALL_ERROR_MESSAGE = "PAYWALL_REQUIRED";

export class PaywallRequiredError extends Error {
  constructor(message = PAYWALL_ERROR_MESSAGE) {
    super(message);
    this.name = "PaywallRequiredError";
  }
}

export function isPaywallRequiredError(err: unknown): boolean {
  return err instanceof PaywallRequiredError || (err instanceof Error && err.message === PAYWALL_ERROR_MESSAGE);
}
